import {
  ADDITIONAL_PAGES_ROUTE,
  BRAND_WEBSITE_BUSINESS_CATEGORIES,
  CUSTOM_DOMAIN_ROUTE,
  SUBSCRIPTION,
  SUBSCRIPTION_DETAILS,
  SUBSCRIPTION_RENEWAL,
  SUBSCRIPTION_STATUS_DETAILS,
  WHATSAPP_BUSINESS_DEMO,
  WORKSPACE_PREPURCHASE_ROUTE,
} from "../../../Constants/routesConstant";

const isDashy = !location.pathname.includes("webview");

export const PREMIUM_PAGE_ROUTES = {
  VIEW_ACTIVE_SUBCRIPTION: {
    url: SUBSCRIPTION_STATUS_DETAILS,
    digitalDukaanRoute: "",
  },

  COMPARE_PLANS: {
    url: SUBSCRIPTION,
    digitalDukaanRoute: "",
  },

  EXPLORE_MORE_DOMAINS: {
    url: CUSTOM_DOMAIN_ROUTE,
    digitalDukaanRoute: "/domain-explore",
  },

  EXPLORE_THEME: {
    url: "/themes-explore",
    digitalDukaanRoute: "/theme-explore",
  },

  WHATSAPP_MARKETING: {
    url: isDashy ? WHATSAPP_BUSINESS_DEMO : "/whatsapp-business-marketing",
    digitalDukaanRoute: "",
  },

  GOOGLE_WORKSPACE: {
    url: WORKSPACE_PREPURCHASE_ROUTE,
    digitalDukaanRoute: "/workspace-purchase",
  },

  GST_BILLING: {
    url: "",
    digitalDukaanRoute: "",
  },

  GET_IT_NOW: {
    url: "",
    digitalDukaanRoute: "/domain-cart",
  },

  RENEW_DOMAIN_SUBSCRIPTION: {
    url: "",
    digitalDukaanRoute: "/domain-renewal-details",
  },

  VIEW_DOMAIN_DETAILS: {
    url: "/domain-history",
    digitalDukaanRoute: "/domain-list",
  },

  RENEW_WORKSPACE_SUBSCRIPTION: {
    url: "",
    digitalDukaanRoute: "/workspace-renewal",
  },

  VIEW_WORKSPACE_DETAILS: {
    url: "/workspace",
    digitalDukaanRoute: "/workspace-manager",
  },

  EXPLORE_BRAND_WEBSITE: {
    url: BRAND_WEBSITE_BUSINESS_CATEGORIES,
    digitalDukaanRoute: "",
  },

  ECOMM_PACK_SUBSCRIPTION_DETAILS: {
    url: SUBSCRIPTION_DETAILS,
    digitalDukaanRoute: "",
  },

  ECOMM_PACK_RENEW: {
    url: SUBSCRIPTION_RENEWAL,
    digitalDukaanRoute: "",
  },

  EXPLORE_ADDITIONAL_PAGES: {
    url: ADDITIONAL_PAGES_ROUTE,
    digitalDukaanRoute: "",
  },
};

export const LIFETIME_ACCESS_DATE = "0000-00-00 00:00:00";

export const SUBSCRIPTIONS = {
  DOMAIN: "domain",
  EXTERNAL_DOMAIN: "external-domain",
  ECOMM_THEME: "ecomm-theme",
  BRAND_WEBSITE_THEME: "brand-website-theme",
  ECOMM_PACK: "ecomm-pack",
  WORKSPACE: "workspace",
  WABA: "waba",
  GST: "gst",
  TITAN_WORKSPACE: "titan",
  GOOGLE_WORKSPACE: "google",
};

export const SUBSCRIPTION_STATUS_TEXT = {
  LIFETIME_ACCESS: "Lifetime Access",
  ACTIVE: "",
  ABOUT_TO_EXPIRE: "Expires soon",
  EXPIRED: "Expired",
  BLOCKED: "Blocked",
};

export const ACTIVE_SUBSCRIPTION_CTA_TEXT = {
  DOMAIN: {
    RENEW: "Renew",
    VIEW_DETAILS: "Details",
  },
  THEME: {
    EDIT: "Edit",
  },
  BRAND_WEBSITE: {
    RENEW: "Renew",
    CHANGE_THEME: "Change Theme",
  },
  WORKSPACE: {
    RENEW: "Renew",
    CONTACT_US: "Contact Us",
    VIEW_DETAILS: "Details",
  },
  ECOMM: {
    RENEW: "Renew",
    VIEW_BENFITS: "Benefits",
    NO_TEXT: "",
  },
  WABA: {
    RENEW: "Renew",
    VIEW_DETAILS: "Details",
  },
  GST: {
    RENEW: "Renew",
    NO_TEXT: "",
  },
  EXTERNAL_DOMAIN: {
    VIEW_DETAILS: "Details",
  },
  TITAN: {
    VIEW_DETAILS: isDashy ? "View Details" : "Details",
  },
};

export const CALLBACK_INFO = {
  BRAND_WEBSITE: {
    text: "brand_website_expiry",
    feature_name: "brand_website",
  },
  WABA: {
    text: "waba_expiry",
    feature_name: "waba",
  },
  GST: {
    text: "gst_expiry",
    feature_name: "gst",
  },
};
